import React from 'react'
import { useRouter } from 'next/router'

import { useAuth } from 'utils/auth'
import { useAPIGetProfileInfoById } from 'api/profile/useAPIProfile'

export const useProfileInfo = () => {
  const router = useRouter()
  const { session } = useAuth()

  const profileId = decodeURI(
    (router.query.id ?? session?.user?.id ?? '') as string
  ).trim()

  const { data: profileInfoResponse, status: profileInfoFetchStatus } =
    useAPIGetProfileInfoById(profileId)

  const profileInfoData = React.useMemo(
    () => profileInfoResponse?.data,
    [profileInfoResponse?.data]
  )
  const { socialMedia = {}, ...profileInfo } = profileInfoData ?? {}
  const hasProfileInfo = Object.values(profileInfo).some((item) =>
    Boolean(item)
  )
  const hasSocialMedia = Object.values(socialMedia).some((item) =>
    Boolean(item)
  )
  const isProfileInfoEmpty = !hasProfileInfo && !hasSocialMedia

  return {
    profileInfoData,
    profileInfoFetchStatus,

    hasProfileInfo,
    hasSocialMedia,
    isProfileInfoEmpty,
  }
}
